import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig } from '@angular/core';
import { environment } from '../environments/environment';
import {
  provideRouter,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
} from '@angular/router';
import {
  LogLevel,
  authInterceptor,
  autoLoginPartialRoutesGuard,
  provideAuth,
} from 'angular-auth-oidc-client';

import { routes } from './app.routes';
import { provideApplicationInsights } from './provideApplicationInsights'; 

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';


// Factory function for loading translations
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}


export const appConfig: ApplicationConfig = {
  providers: [
    provideApplicationInsights(),
    provideRouter(routes, withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }), withEnabledBlockingInitialNavigation()),
    provideHttpClient(withInterceptors([authInterceptor()])),
    provideAuth({
        config: [{
          authority: environment.auth.authority,
          authWellknownEndpointUrl: environment.auth.authWellknownEndpointUrl,
          redirectUrl: environment.auth.redirectUrl,
          clientId: environment.auth.clientId,
          scope: environment.auth.scope,
          responseType: environment.auth.responseType,
          silentRenew: true,
          maxIdTokenIatOffsetAllowedInSeconds: 600,
          issValidationOff: true,
          autoUserInfo: false, 
          useRefreshToken: true,
          logLevel: LogLevel.Debug,
          customParamsAuthRequest: {
            prompt: 'select_account', // login, consent
          },
          postLogoutRedirectUri: window.location.origin,
          secureRoutes: [environment.urlApi]
        },        
        {
          authority: environment.auth.authority,
          authWellknownEndpointUrl: environment.auth.authWellknownEndpointUrl,
          redirectUrl: environment.auth.redirectUrl,
          clientId: environment.auth.clientId,
          scope: "User.Read",
          responseType: environment.auth.responseType,
          silentRenew: true,
          maxIdTokenIatOffsetAllowedInSeconds: 600,
          issValidationOff: true,
          autoUserInfo: false, 
          useRefreshToken: true,
          logLevel: LogLevel.Debug,
          customParamsAuthRequest: {
            prompt: 'select_account', // login, consent
          },
          postLogoutRedirectUri: window.location.origin,
          secureRoutes: [environment.urlGraph]
        }]
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }).providers!,
    /*
    provideRouter(
      [
        { path: '', pathMatch: 'full', redirectTo: 'home' },
        { path: 'home', component: HomeComponent },
        {
          path: 'protected',
          component: ProtectedComponent,
          canActivate: [autoLoginPartialRoutesGuard],
        },
        {
          path: 'forbidden',
          component: ForbiddenComponent,
          canActivate: [autoLoginPartialRoutesGuard],
        },
        {
          path: 'customers', 
          loadChildren: () =>
            import('./customers/customers.routes').then((m) => m.routes),
          canMatch: [autoLoginPartialRoutesGuard],
        },
        { path: 'unauthorized', component: UnauthorizedComponent },
      ],
      withEnabledBlockingInitialNavigation()
    ),*/
  ],
};
